import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import {
  IconUsers,
  IconCalendar,
  IconMessageCircle,
  IconBrandWhatsapp,
} from "@tabler/icons-react";
import UserContext from "../../../contexts/UserContext";

const BottomNavigation = () => {
  const { bottyData } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  return (
    <BottomNavContainer className="bottom-navigation">
      {/* Contatos */}
      <NavItem
        active={isActive("/crm")}
        onClick={() => handleNavigation("/crm")}
      >
        <IconContainer active={isActive("/crm")}>
          <IconUsers size={24} />
        </IconContainer>
        <NavLabel active={isActive("/crm")}>CRM</NavLabel>
      </NavItem>

      {/* Agenda - Item central maior */}
      <CentralNavItem
        active={isActive("/calendar")}
        onClick={() => handleNavigation("/calendar")}
      >
        <CentralIconContainer active={isActive("/calendar")}>
          <IconCalendar size={28} />
        </CentralIconContainer>
        <NavLabel active={isActive("/calendar")}>Agenda</NavLabel>
      </CentralNavItem>

      {/* Chat - só aparece se bottyData?.uid existir */}
      {/* {bottyData?.uid && ( */}
      <NavItem
        active={isActive("/chat")}
        onClick={() => handleNavigation("/chat")}
      >
        <IconContainer active={isActive("/chat")}>
          <IconBrandWhatsapp size={24} />
        </IconContainer>
        <NavLabel active={isActive("/chat")}>Whatsapp</NavLabel>
      </NavItem>
      {/* )} */}
    </BottomNavContainer>
  );
};

// Container principal do bottom navigation
const BottomNavContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 65px;
  background-color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 20px;
  z-index: 1000;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    display: none; /* Esconde em telas maiores */
  }
`;

// Item de navegação normal
const NavItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 12px;
  transition: all 0.2s ease;
  min-width: 60px;

  &:hover {
    background-color: rgba(var(--primary-rgb, 59, 130, 246), 0.1);
  }
`;

// Item central (Agenda) - destaque maior
const CentralNavItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 16px;
  transition: all 0.2s ease;
  min-width: 70px;
  position: relative;
  top: -5px; /* Eleva ligeiramente o item central */

  &:hover {
    background-color: rgba(var(--primary-rgb, 59, 130, 246), 0.1);
  }
`;

// Container do ícone normal
const IconContainer = styled.div`
  padding: 6px;
  border-radius: 12px;
  background-color: ${(props) =>
    props.active ? "var(--primary, #3b82f6)" : "transparent"};
  color: ${(props) => (props.active ? "#fff" : "#6b7280")};
  transition: all 0.2s ease;
  margin-bottom: 2px;

  svg {
    display: block;
  }
`;

// Container do ícone central (maior e mais destacado)
const CentralIconContainer = styled.div`
  padding: 10px;
  border-radius: 16px;
  background-color: ${(props) =>
    props.active ? "var(--primary, #3b82f6)" : "#f3f4f6"};
  color: ${(props) => (props.active ? "#fff" : "#6b7280")};
  transition: all 0.2s ease;
  margin-bottom: 4px;
  box-shadow: ${(props) =>
    props.active
      ? "0 4px 12px rgba(var(--primary-rgb, 59, 130, 246), 0.3)"
      : "0 2px 8px rgba(0, 0, 0, 0.1)"};

  svg {
    display: block;
  }
`;

// Label dos itens
const NavLabel = styled.span`
  font-size: 10px;
  font-weight: 500;
  color: ${(props) => (props.active ? "var(--primary, #3b82f6)" : "#6b7280")};
  text-align: center;
  transition: color 0.2s ease;
  margin-top: 2px;
`;

export default BottomNavigation;
